import { Text } from '@chakra-ui/core'
import React from 'react'
import { CalendarDays } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { ActionButton, IconBlock } from './NavMenu'
import keys from 'constants/keys'

export const StoreePlannerButton: React.FC = () => {
  return (
    <NavLink
      to={keys.ROUTE_NAMES.EXTERNAL_APP}
      state={{ url: 'https://notorious-story-shift-flow.base44.app', title: 'STOREE planner' }}
      style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <ActionButton>
        <IconBlock bg="#E0F2FE" borderRadius="10px" alignItems="center" justifyContent="center">
          <CalendarDays size={18} color="#0284C7" />
        </IconBlock>
        <Text fontSize="14px">Planner</Text>
      </ActionButton>
    </NavLink>
  )
}
